const GenericStyleGuide = {
  color: {
    lightBlue: "#51ACE4",
    lightGreen: "#51b1e4",
    lightOrange: "#F19F9C",
    lightRed: "#bd7ab3",
    lightGray: "#eaeaea",
    middleGray: "#c6c8c7",
    black: "#000000",
    brightYellow: "#F2D315",
    brightRed: "#ff0000",
    brightGreen: "#33A532",
    notebookBeige: "#fff8e9",
    softPurple: "#8368EE",
    pdfPink: "#b97ab4",
    SOSBlue: "#0d0047",
    white: "#ffffff",
    darkBlue: "#2c3e50",
    boxShadow: "#b5b5b5"
  },
  font: {
    size: {
      finePrint: ".8em",
      tiny: "1em",
      small: "1.2em",
      mediumSmall: "1.5em",
      medium: "2em",
      mediumLarge: "2.5em",
      large: "3em",
      huge: "4.0em",
      massive: "4.5em"
    },
    family: {
      helveticaNeue: "helvetica neue",
      monoFur: "MonoFur",
      chivo: "Chivo",
      gothamBook: "Gotham-Book",
      gothamMedium: "Gotham-Medium",
      gothamLight: "Gotham-Light",
      axis: "Axis",
      didact: "Didact Gothic"
    },
    weight: {
      oneHundred: "100",
      twoHunderd: "200",
      threeHunded: "300",
      fourHundred: "400",
      fiveHundred: "500",
      sixHundred: "600",
      sevenHundred: "700",
      eightHundred: "800",
      nineHundred: "900",
      light: "100",
      medium: "400",
      heavy: "700"
    }
  }
};
export default GenericStyleGuide;
